import request from '@/utils/request';

/**
 * 医院 列表
 */
export function hospitalListApi(params) {
  return request({
    url: '/admin/platform/hospital/list',
    method: 'get',
    params: params
  });
}

/**
 * 医院 添加
 */
export function hospitalAddApi(data) {
  return request({
    url: '/admin/platform/hospital/add',
    method: 'post',
    data: data
  });
}

/**
 * 医院 添加
 */
export function hospitalEditApi(data) {
  return request({
    url: '/admin/platform/hospital/edit',
    method: 'post',
    data: data
  });
}

/**
 * 医院 添加
 */
export function hospitalDelApi(id) {
  return request({
    url: "/admin/platform/hospital/delete?id=".concat(id),
    method: 'post'
  });
}

/**
 * 医生 列表
 */
export function doctorListApi(params) {
  return request({
    url: '/admin/platform/hospital/doctor/list',
    method: 'get',
    params: params
  });
}

/**
 * 医院 添加
 */
export function doctorAddApi(data) {
  return request({
    url: '/admin/platform/hospital/doctor/add',
    method: 'post',
    data: data
  });
}

/**
 * 医院 编辑
 */
export function doctorEditApi(data) {
  return request({
    url: '/admin/platform/hospital/doctor/edit',
    method: 'post',
    data: data
  });
}

/**
 * 删除医生
 * @param data
 * @returns {AxiosPromise}
 */
export function doctorDeleteApi(id) {
  return request({
    url: "/admin/platform/hospital/doctor/delete?id=".concat(id),
    method: 'post'
  });
}

/**
 * 医生 列表
 */
export function departmentListApi(params) {
  return request({
    url: '/admin/platform/hospital/department/list',
    method: 'get',
    params: params
  });
}
export function departmentAddApi(data) {
  return request({
    url: '/admin/platform/hospital/department/add',
    method: 'post',
    data: data
  });
}
export function departmentEditApi(data) {
  return request({
    url: '/admin/platform/hospital/department/edit',
    method: 'post',
    data: data
  });
}

/**
 * 删除科室
 */
export function departmentDeleteApi(id) {
  return request({
    url: "/admin/platform/hospital/department/delete?id=".concat(id),
    method: 'post'
  });
}